import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'
import { imageUrl } from '../helpers'

interface Props {
  id?: number
  className?: string
}

const iconCache = new Map<number, string>()
const BLIZZARD_ICON_BASE = 'https://render.worldofwarcraft.com/us/icons/36'
const ZAMIMG_ICON_BASE = 'https://wow.zamimg.com/images/wow/icons/large'

type IconSource = 'local' | 'blizzard' | 'zamimg'

const ItemIcon = ({ id, className }: Props) => {
  const [icon, setIcon] = useState<string | null>(
    id ? iconCache.get(id) ?? null : null,
  )
  const [source, setSource] = useState<IconSource>('local')

  useEffect(() => {
    setSource('local')
    if (!id) return
    if (iconCache.has(id)) {
      setIcon(iconCache.get(id) ?? null)
      return
    }
    fetch(`https://nether.wowhead.com/tooltip/item/${id}`).then(
      async (response) => {
        const json = await response.json()
        const resolved = json.icon?.replaceAll('-', '') || null
        if (resolved) iconCache.set(id, resolved)
        setIcon(resolved)
      },
    )
  }, [id])

  const src = icon
    ? {
        local: imageUrl(`item-icons/${icon}.jpg`),
        blizzard: `${BLIZZARD_ICON_BASE}/${icon}.jpg`,
        zamimg: `${ZAMIMG_ICON_BASE}/${icon}.jpg`,
      }[source]
    : undefined

  return (
    <figure className={cn('w-5 h-5', className)}>
      <img
        className={`w-full h-full duration-300 ${
          icon ? 'opacity-100' : 'opacity-0'
        } transition-opacity`}
        src={src}
        onError={() => {
          if (!icon || source === 'zamimg') return
          setSource(source === 'local' ? 'blizzard' : 'zamimg')
        }}
      />
    </figure>
  )
}

export default ItemIcon
